import { LDClient, LDContext, initialize } from 'launchdarkly-js-client-sdk';
import { Account, User } from '@cliengo/mfe-utils/types';

import config from '@/config/environment';

declare global {
  interface Window {
    cliengo_ld_client: LDClient;
  }
}

export class LaunchDarklyClientSingleton {
  private static instance: LaunchDarklyClientSingleton;
  private client: LDClient;

  private constructor(user: User, account: Account) {
    const ldContext: LDContext = {
      kind: 'user',
      key: user.id,
      companyId: account.id,
      custom: {
        companyId: account.id,
        whiteLabelId: account.whiteLabelId,
        whiteLabelName: account.whiteLabelName,
        countryId: account.countryId,
        companyCreationDate: Math.floor(
          new Date(account.creationDate).getTime() / 1000
        ),
        affiliate: account.affiliate,
        affiliateProgramCode: account.affiliateProgramCode,
        creationDate: new Date(account.creationDate).getTime(),
        planType: account.planType,
      },
    };

    const client = initialize(config.LAUNCHDARKLY_KEY, ldContext);

    window.cliengo_ld_client = client;
    this.client = client;
  }

  public static getInstance() {
    if (!initialize) {
      console.warn('LaunchDarkly not initialized and getInstance was called');
    }
    return LaunchDarklyClientSingleton.instance;
  }

  public static async initInstance(user: User, account: Account) {
    if (!LaunchDarklyClientSingleton.instance) {
      LaunchDarklyClientSingleton.instance = new LaunchDarklyClientSingleton(
        user,
        account
      );
      await LaunchDarklyClientSingleton.instance.client.waitUntilReady();
    }

    return true;
  }

  public evaluateFlag<T = boolean>(flag: string, defaultValue?: T) {
    const flagValue = this.client.variation(flag, defaultValue) as T;

    return flagValue;
  }
}

export const getLDClient = () => LaunchDarklyClientSingleton.getInstance();

export const initLaunchDarkly = async (user: User, account: Account) => {
  return await LaunchDarklyClientSingleton.initInstance(user, account);
};
